import { render, staticRenderFns } from "./NewIndex.vue?vue&type=template&id=76c4b374&scoped=true"
import script from "./NewIndex.vue?vue&type=script&lang=js"
export * from "./NewIndex.vue?vue&type=script&lang=js"
import style0 from "./NewIndex.vue?vue&type=style&index=0&id=76c4b374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c4b374",
  null
  
)

export default component.exports